import styled from 'styled-components/macro'
import { mobile } from "../../theme";

export default styled.div`
  flex-shrink: 0;
  width: 300px;

  ${mobile`
    display: none;
  `}
`;
